import timeOffInputStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_NOTES', function setNotesInStore(notes: string) {
    timeOffInputStore.notes = notes;
});
